import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { updateCompany2, companyUpdated } from 'actions/company';
import { Link } from 'react-router';
import NotFound from 'components/NotFound';
import NavBarConfig from 'components/NavBarConfig';
import CompanyUpdate from 'components/company/CompanyUpdate';
import { FORM_ERROR } from 'final-form';

const messages = defineMessages({
  EDIT_COMPANY: { id: 'CompanyUpdatePage.EDIT_COMPANY', defaultMessage: 'Unternehmensprofil' },
  TITLE: { id: 'CompanyCustomizeMailPage.TITLE', defaultMessage: 'E-Mail Vorlage' },
  DESCRIPTION: { id: 'CompanyCustomizeMailPage.DESCRIPTION', defaultMessage: 'Hier können Sie den Text für die E-Mail-Vorlage anpassen. Am Ende des Textes wird automatisch ein Link eingefügt. Der Absender der E-Mail ist immer die E-Mail-Adresse des jeweiligen Nutzers (z.B. über Outlook).' },
  SAVE_ERROR: { id: 'CompanyCustomizeMailPage.SAVE_ERROR', defaultMessage: 'Fehler beim Speichern' },
});

class CompanyCustomizeMailPage extends Component {
  render() {
    const { user, company, companyMembership, onSubmit, routes, intl: { formatMessage } } = this.props;
    const isGlobalAdmin = user && user.is_admin;
    const isCompanyAdmin = companyMembership && (companyMembership.is_owner || companyMembership.is_admin);

    if (!company || !companyMembership) { return null; }
    if (!isGlobalAdmin && !isCompanyAdmin) {
      return <NotFound />;
    }

    return (
      <div style={{ padding: '16px', backgroundColor: 'transparent', minHeight: '100vh', width: '100%' }}>
        <NavBarConfig updatePage currentRouteName={routes[routes.length - 1].name} />
        
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: 'var(--panel-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: '18px', border: '1px solid var(--panel-border)' }}>
                <i className="fa fa-envelope" />
              </div>
              <div>
                {formatMessage(messages.TITLE)}
                <span style={{ display: 'block', fontSize: '14px', fontWeight: 'normal', color: 'var(--text-muted)', marginTop: '4px' }}>
                  {company.name}
                </span>
              </div>
            </h2>
          </div>

          {/* Main Card */}
          <div style={{ maxWidth: '800px', backgroundColor: 'var(--panel-bg)', borderRadius: '12px', boxShadow: '0 4px 6px -1px var(--panel-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
            <div style={{ padding: '32px' }}>
              <div style={{ maxWidth: '600px' }}>
                <p style={{ color: 'var(--text-muted)', fontSize: '14px', marginBottom: '24px', lineHeight: '1.5' }}>
                  {formatMessage(messages.DESCRIPTION)}
                </p>
                <CompanyUpdate onSubmit={onSubmit} initialValues={company} isAdmin={isGlobalAdmin} mode="mail" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    ...state.companySingle,
    user: state.auth.user
  }),
  (dispatch, props) => ({
    navigate: url => dispatch(push(url)),
    onSubmit: async (values) => {
      const { error, response } = await updateCompany2(props.params.companyId, values);
      if (error) {
        return { [FORM_ERROR]: error.message || error._error || 'Fehler beim Speichern' };
      }
      if (response) {
        dispatch(companyUpdated(response));
      }
    }
  })
)(injectIntl(CompanyCustomizeMailPage));
